import React from "react";
import {
  X,
  Clock,
  CheckCircle2,
  CircleDot,
  User,
  MessageSquare,
} from "lucide-react";
import frameBg from "../../Assets/FrameBGDashboard.png";

const TicketHistoryModal = ({ show, onClose, history }) => {
  if (!show) return null;

  const formatDateTime = (d) => {
    if (!d) return "—";
    return new Date(d).toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-end z-50 transition-opacity duration-300 opacity-100"
      onClick={onClose}
    >
      <div
        className="bg-[#F5FAFC] w-full max-w-xl h-full shadow-2xl border-l animate-slideFadeIn flex flex-col overflow-hidden rounded-l-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          className="p-5 text-white shadow-md bg-cover bg-center bg-no-repeat flex justify-between items-center"
          style={{ backgroundImage: `url(${frameBg})` }}
        >
          <h2 className="text-xl font-semibold tracking-wide flex items-center gap-2">
            <Clock size={22} /> Turn-Around Time(TAT)
          </h2>

          <button
            onClick={onClose}
            className="text-white hover:text-gray-200 transition"
          >
            <X size={26} />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto px-6 py-6 relative">

          {history.length === 0 && (
            <p className="text-center text-gray-500 mt-10">No history found.</p>
          )}

          {history.map((item, index) => (
            <div key={index} className="relative pl-10 mb-10">

              {/* Vertical Line*/}
              {index !== history.length - 1 && (
                <div className="absolute left-4 top-6 w-[2px] h-full bg-gradient-to-b from-[#00ACED] to-[#0061A4]" />
              )}

              {/* Timeline Dot */}
              <div className="absolute left-0 top-2 bg-white border border-[#00ACED]/40 rounded-full p-1 shadow">
                {item.timeStamp ? (
                  <CheckCircle2 size={20} className="text-[#00ACED]" />
                ) : (
                  <CircleDot size={20} className="text-gray-400" />
                )}
              </div>

              {/* CARD*/}
              <div className="bg-white p-4 rounded-xl border shadow-sm">
                <div className="flex items-center gap-2 text-gray-600 text-sm">
                  <Clock size={16} />
                  <span>{formatDateTime(item.timeStamp)}</span>
                </div>

                <div className="mt-2 flex items-center gap-2 text-gray-800">
                  <User size={18} className="text-[#0061A4]" />
                  <span className="text-sm">
                    <strong>Updated By:</strong> {item.updatedBy || "—"}
                  </span>
                </div>

                <div className="mt-3 bg-gray-50 border rounded-lg p-3 space-y-1">
                  {item.changes.map((c, i) => (
                    <div key={i} className="text-gray-800 text-sm">
                       {c}
                    </div>
                  ))}
                </div>

                {item.remark && (
                  <div className="mt-3 bg-blue-50 border rounded-lg p-3 flex gap-2">
                    <MessageSquare size={16} className="text-blue-600 mt-1" />
                    <p className="text-gray-700 italic text-sm">
                      "{item.remark}"
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="p-4 bg-gray-100 border-t flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 text-sm bg-white border rounded-md hover:bg-gray-200 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TicketHistoryModal;
